module.exports = __webpack_public_path__ + "img/partner_52.83f05489.png";